import React from 'react';
import styles from './QuoteBox.module.css';

interface QuoteBoxProps {
  quote: string;
}

export const QuoteBox: React.FC<QuoteBoxProps> = ({ quote }) => {
  return (
    <section className={styles.quoteBox}>
      <blockquote className={styles.quote}>
        {quote.split(' ').map((word, index, arr) => (
          <React.Fragment key={index}>
            {word}
            {index === Math.floor(arr.length / 2) - 1 && <br />}
            {index !== arr.length - 1 && index !== Math.floor(arr.length / 2) - 1 && ' '}
          </React.Fragment>
        ))}
      </blockquote>
    </section>
  );
};
